// checkbox tree

import React from "react";
import { Checkbox, CheckboxGroup } from 'rsuite';

class WidgetCheckbox extends React.Component
{
    constructor(props)
    {

        super(props);

        this.state={
            indeterminate: true,
            checkAll: false,
            value: undefined,
            data : props.data
        };

        this.handleCheckAll=this.handleCheckAll.bind(this);
        this.handleChange=this.handleChange.bind(this);
        this.findValue.bind(this);
        this.clear = this.clear.bind(this);

        if( this.props.onRef!==undefined )
        {
            this.props.onRef(this)
        }
    }

    componentDidMount()
    {
        let values = [];
        if( this.props.value!==undefined && this.props.value.length>0 )
        {
            for( let item of this.props.value )
            {
                values.push(item.code);

            }
        }
        this.setState({value:values});
    }

    // componentWillReceiveProps( nextProps )
    // {
    //     this.setState({
    //         value:[]
    //     })
    // }

    // componentWillReceiveProps( nextProps )
    // {
    //     let values = [];
    //     if( nextProps.value!==undefined && nextProps.value.length>0 )
    //     {
    //         for( let item of nextProps.value )
    //         {
    //             values.push(item.code);

    //         }
    //     }
    //     this.setState({value:values});
    // }

    handleCheckAll(value, checked)
    {
        let {data} = this.props;

        const nextValue = checked ? data : [];
        value = this.findValue(nextValue);

        this.setState({
          value: value,
          indeterminate:false,
          checkAll: checked
        });

        if( this.props.onChange!==undefined )
        {
            this.props.onChange(value, nextValue);
        }
    }

    clear()
    {
        this.setState({value:[],checkAll:false})
    }

    handleChange(value)
    {
        let {data} = this.props;

        this.setState({
          value,
          indeterminate:(value.length > 0 && value.length < data.length),
          checkAll: value.length === data.length
        });

        if( this.props.onChange!==undefined )
        {
            this.props.onChange(value, this.findData(value));
        }
    }

    findData( value )
    {
        let {data} = this.props, array = [];

        for( let i in data )
        {
            if( value.includes(data[i].code) )  array.push(data[i]);
        }

        return array;
    }

    findValue( data )
    {
        let array = [];

        for( let i in data )
        {
            array.push(data[i].code);
        }

        return array;
    }

    render(){

        let {data } = this.props;

        return (
          <div>
            <Checkbox
                indeterminate={this.state.indeterminate}
                checked={this.state.checkAll}
                onChange={this.handleCheckAll}>
                查找范围
            </Checkbox>

            <CheckboxGroup
                inline
                name="checkboxList"
                value={this.state.value}
                onChange={this.handleChange}
              >
            {
                data.map((item, index) =>{
                    return <Checkbox value={item.code || ""} key={index}>{item.title}</Checkbox>
                })
            }
            </CheckboxGroup>
          </div>
        )
    }
}

export default WidgetCheckbox;